import React from "react";
import Tooltip from "@mui/material/Tooltip";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useSearchParams } from "react-router-dom";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import {
  ClipsTabParam,
  buildShareClipUrl,
} from "./ClipsUtilities/clipsUrlParams";

const fallbackCopyToClipboard = async (value: string): Promise<void> => {
  const textArea = document.createElement("textarea");
  textArea.value = value;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "absolute";
  textArea.style.left = "-9999px";
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand("copy");
  document.body.removeChild(textArea);
};

export const ShareClipUrlButton = ({
  tab,
  selectedRow,
}: {
  tab: ClipsTabParam;
  selectedRow: any;
}) => {
  const [searchParams] = useSearchParams();
  const [copiedOpen, setCopiedOpen] = React.useState(false);
  const shareUrl = React.useMemo(
    () => buildShareClipUrl(tab, selectedRow, searchParams),
    [tab, selectedRow, searchParams]
  );

  const handleCopy = async () => {
    if (!shareUrl) return;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(shareUrl);
      } else {
        await fallbackCopyToClipboard(shareUrl);
      }
      setCopiedOpen(true);
    } catch {
      // no-op, button remains enabled and user can retry
    }
  };

  return (
    <>
      <Tooltip title="Copy clip URL to clipboard" arrow>
        <span>
          <OrangeTextButton
            onClick={handleCopy}
            text="Share clip URL"
            disabled={!shareUrl}
          />
        </span>
      </Tooltip>
      <Snackbar
        open={copiedOpen}
        autoHideDuration={4000}
        onClose={() => setCopiedOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity="success"
          onClose={() => setCopiedOpen(false)}
          sx={{ width: "100%", fontFamily: "Mulish" }}
        >
          Clip was successfully copied to clipboard
        </MuiAlert>
      </Snackbar>
    </>
  );
};
